import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionRoomAmenities } from "./amenities";
import { QuestionRoomBedType } from "./bed-type";
import { QuestionRoomSize } from "./room-size";

import type { StandardRoomCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	roomDetailInfo: StandardRoomCategoriesAndManagerStore["roomDetailInfo"];
};

export const QuestionRoomDetailInfo = ({ roomDetailInfo }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper categoryStore={roomDetailInfo}>
			<QuestionRoomSize />
			<QuestionRoomBedType />
			<QuestionRoomAmenities />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionRoomDetailInfo.displayName = "QuestionRoomDetailInfo";
